import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import GlobalModal from '../modal';
import AuthButton from '../../external/auth-button';

interface Props {
  title?: string | ReactNode;
  message?: string | ReactNode;
  name?: string;
  buttons?: ReactNode;
  onClose: () => void;
}

export default function ExternalMessageModal({
  title,
  message,
  name = 'external-modal',
  buttons,
  onClose,
}: Props) {
  const { t } = useTranslation();

  return (
    <GlobalModal
      visible={true}
      onClose={onClose}
      name={name}
      title={title}
      body={message}
      buttons={
        buttons ? (
          buttons
        ) : (
          <div className="pt-4 text-center">
            <AuthButton name="agree" onClick={() => onClose()}>
              {t('components.modals.agree')}
            </AuthButton>
          </div>
        )
      }
    />
  );
}
